import SpindlLogo from './SpindlLogo';
import { SpindlLogoProps, SpindlLogoValueProps } from './types';

export type { SpindlLogoProps, SpindlLogoValueProps };
export default SpindlLogo;
